import React, { useState, useEffect } from "react";
import { Grid, Button } from "@mui/material";
import api from "api/axios";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const SalesOrders = () => {
  const [salesOrders, setSalesOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSalesOrders = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/quickbooks/sales-orders/`);
        console.log("sales & orders: ", response.data);
        const salesOrderRows = response.data.orders.map((order) => ({
          id: order.id,
          clientName: order.clientName,
          totalAmount: order.totalAmount,
          status: order.status,
          date: order.date,
        }));
        setSalesOrders(salesOrderRows);
      } catch (err) {
        console.error("Failed to fetch sales orders:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSalesOrders();
  }, []);

  const columns = [
    { Header: "Client Name", accessor: "clientName", align: "left" },
    { Header: "Total Amount", accessor: "totalAmount", align: "left" },
    { Header: "Status", accessor: "status", align: "left" },
    { Header: "Date", accessor: "date", align: "left" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="flex-end">
          <Button variant="contained" color="primary">
            Add Sales Order
          </Button>
        </Grid>
        <MDBox pt={3}>
          <DataTable table={{ columns, rows: salesOrders }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default SalesOrders;
